import React, { Component } from "react";
import PropTypes from "prop-types";
import $ from "jquery";
import "bootstrap";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import queryString from "query-string";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import { formatMnDate } from "@mnjsplatform/data/lib/utils/formatData";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import { initSubgrid } from "@mnjsplatform/data/lib/actions/subgridActions";
import ServicesActEditDocumentsSubgrid from "./ServicesActEditDocumentsSubgrid";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import DrawAttribute from "@mnjsplatform/components/lib/common/GridView/DrawAttributeProvider";

class ServicesActEdit extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
        initialized: false,
        subGridExpandState: {},
        subGridKeys: {},
        updateGridFlag: null
      };
  }

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.initialize();
    }

    if(this.props.servicesActPLLinkedList.rowsCount() < prevProps.servicesActPLLinkedList.rowsCount())
      this.props.dispatch(this.props.servicesActPLList.refresh({}, {withParams: true}))
          .then(() => {
            this.initializeBsTooltips();
          });
  }

  componentWillUnmount() {

    //this.setState({ subGridKeys: null, subGridExpandState: null});
  };

  initialize = async () => {
    try {
      this.setState({initialized: false});

      await this.props.dispatch(this.props.servicesActDescribe.reset());
      await this.props.dispatch(this.props.servicesActPLList.reset());
      await this.props.dispatch(this.props.servicesActPLLinkedList.reset());

      let params = {DocumentIntId: this.getDocumentIdFromQuery()};
      await this.props.dispatch(this.props.servicesActDescribe.execute(params));

      params = {SrcTransportDocumentIntId: this.props.servicesActDescribe.getField(0, "SrcTransportDocumentIntId")};

      await this.props.dispatch(this.props.servicesActPLList.execute(params, {withParams: true, newItem: true}));
      await this.props.dispatch(this.props.servicesActPLLinkedList.execute(params, {withStyle: true}));

      this.initializeBsTooltips();
    }
    finally {
      this.setState({initialized: true});
    }
  };

  initializeBsTooltips = () => {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  };

  onToggleSubGrid = (rowIndex, row, dataItem, subgridFieldName) => {

    let rowKey = JSON.stringify(dataItem.getRowKey(row));
    let methodName = dataItem.methodName;

    let subGridExpandState = this.state.subGridExpandState;

    if(!subGridExpandState[methodName])
      subGridExpandState[methodName] = {};

    let isExpanded = !!subGridExpandState[methodName][rowKey];
    subGridExpandState[methodName][rowKey] = !isExpanded;

    this.setState({ subGridExpandState: subGridExpandState, updateGridFlag: Date.now() });

    if(!isExpanded)
      this.initSubgridCommon(dataItem, subgridFieldName, rowKey, rowIndex);
  };

  initSubgridCommon = (dataItem, fieldName, rowKey, rowIndex) => {
    this.props.dispatch(initSubgrid(dataItem, fieldName, rowIndex, "", true))
      .then(key => {
        let subGridKeys = this.state.subGridKeys;

        if(!subGridKeys[dataItem.methodName])
          subGridKeys[dataItem.methodName] = {};

        subGridKeys[dataItem.methodName][rowKey] = key;

        this.setState({ subGridKeys: subGridKeys, updateGridFlag: Date.now() });
      });
  };

  onCloseSubGrid = (parentDataItem, parentRowKey, subGridKey) => {

    if(this.state.subGridKeys[parentDataItem.methodName] && this.state.subGridKeys[parentDataItem.methodName][subGridKey]) {

      let subGridKeysState = this.state.subGridKeys;
      subGridKeysState[parentDataItem.methodName][parentRowKey] = null;

      this.setState({subGridKeys: subGridKeysState});
    }
  };

  getDocumentIdFromQuery = () => {
    let pageParams = queryString.parse(this.props.location.search);
    return pageParams.DocumentIntId ? pageParams.DocumentIntId : null;
  };

  isActEditable = () => {

    if(!this.props.servicesActDescribe.isInitialized || this.props.servicesActDescribe.inOperation)
      return false;

    return this.props.servicesActDescribe.getField(0, "AllowEdit") === 1;
  };

  onLinkPickupList = async(row) => {
    if(!this.isActEditable())
      return;

    let params = { SrcTransportDocumentIntId: this.props.servicesActDescribe.getField(0, "SrcTransportDocumentIntId") };

    await this.props.dispatch(this.props.servicesActPLInsertList.execute(row));
    await this.props.dispatch(this.props.servicesActPLList.execute(params));
    await this.props.dispatch(this.props.servicesActPLLinkedList.execute(params, {withStyle: true}));
    this.initializeBsTooltips();
  };

  onUnlinkPickupList = async(row) => {
    if(!this.isActEditable())
      return;

    let params = { SrcTransportDocumentIntId: this.props.servicesActDescribe.getField(0, "SrcTransportDocumentIntId") };

    await this.props.dispatch(this.props.servicesActPLDeleteList.execute(row));
    await this.props.dispatch(this.props.servicesActPLList.execute(params));
    await this.props.dispatch(this.props.servicesActPLLinkedList.execute(params, {withStyle: true}));
  };

  onSendActClick = () => {

    let params = { Document_Object: this.props.servicesActDescribe.getField(0, "Document_Object"),
      DocumentDate: this.props.servicesActDescribe.getField(0, "DocumentDate"),
      DocumentNumber: this.props.servicesActDescribe.getField(0, "DocumentNumber")};

    confirm(i18next.t("SendAct"))
      .then(async() => {
        await this.props.dispatch(this.props.servicesActsSend.execute(params));
        await this.props.dispatch(this.props.servicesActsList.refresh());
        this.props.history.goBack();
      });
  };

  navigateBack = () => {
    if (this.props.history.action === "PUSH") {
      this.props.history.goBack();
    }
    else {
      this.props.history.replace("/ServicesActs");
    }
  };

  renderDocumentSubgrid = (dataItem, row, rowIndex) => {

    let rowKey = JSON.stringify(dataItem.getRowKey(row));
    let expanded = this.state.subGridExpandState[dataItem.methodName] && this.state.subGridExpandState[dataItem.methodName][rowKey];

    if(!expanded)
      return null;

    let subGridKey = this.state.subGridKeys[dataItem.methodName] ? this.state.subGridKeys[dataItem.methodName][rowKey] : null;

    return (
      <React.Fragment>
        <tr>
          <td colSpan={100}>
            {!subGridKey &&
              <div className="row fs15">
                <div className="column col-md-12" style={{ textAlign: "center", paddingTop: "15px", paddingBottom: "15px" }}>
                  <span>{i18next.t("LoadingLabel")}</span>
                </div>
              </div>
            }
            {subGridKey &&
              <ServicesActEditDocumentsSubgrid parentDataItem={dataItem}
                                               parentRowKey={rowKey}
                                               subGridKey={subGridKey}
                                               onClose={() => {
                                               }}/>
            }
          </td>
        </tr>
      </React.Fragment>
    );
  };

  renderViewGridParams = (h) => {

    return(
      <React.Fragment>
        <div className="row">
          <div className="col-md-3">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("BeginDate")}
            </div>
            <div>
              {h.ed("BeginDate")}
            </div>
          </div>
          <div className="col-md-3">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("EndDate")}
            </div>
            <div>
              {h.ed("EndDate")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("TemplNumber")}
            </div>
            <div>
              {h.ed("TemplNumber")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="field-title" style={{textAlign: "left"}}>
              {i18next.t("SearchLabel")}
            </div>
            <SearchBar dataItem={this.props.servicesActPLList} />
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderViewGridRow = (row, rowIndex, renderRowDefault, dataItem) => {

    return (
      <React.Fragment>
        {renderRowDefault(row, rowIndex)}
        {this.renderDocumentSubgrid(dataItem, row, rowIndex)}
      </React.Fragment>
    );
  };

  renderViewGridCell = (row, fieldInfo, fieldIndex, renderCellDefault, rowIndex, dataItem, cellAttributes) => {

    let self = this;
    let rowKey = JSON.stringify(dataItem.getRowKey(row));

    if(fieldInfo.Name === "PickupListNumber") {
      let cursorStyle = this.isActEditable() ? "pointer" : "default";

      return(
        <React.Fragment>
          {this.isActEditable() &&
            <span className={"zmdi zmdi-long-arrow-down"} onClick={function(e) { self.onLinkPickupList(row); }} style={{ cursor: cursorStyle, marginLeft: "10px", marginRight: "15px" }}/>
          }

          {renderCellDefault(row, fieldInfo, fieldIndex)}
        </React.Fragment>
      );
    }

    if(fieldInfo.Name === "ComplexRouteGrid") {

      let isExpanded = this.state.subGridExpandState[dataItem.methodName] && this.state.subGridExpandState[dataItem.methodName][rowKey];

      let className = isExpanded ? "zmdi zmdi-chevron-up" : "zmdi zmdi-chevron-down";

      return (
        <span className={className} onClick={function(e) { self.onToggleSubGrid(rowIndex, row, dataItem, "ComplexRouteGrid"); }} style={{ cursor: "pointer", marginLeft: "10px", marginRight: "10px" }}/>
      );
    }

    return renderCellDefault(row, fieldInfo, fieldIndex);
  };

  renderLinkedGridRow = (row, rowIndex, renderRowDefault, dataItem) => {

    return (
      <React.Fragment>
        {renderRowDefault(row, rowIndex)}
        {this.renderDocumentSubgrid(dataItem, row, rowIndex)}
      </React.Fragment>
    );
  };

  renderLinkedGridCell = (row, fieldInfo, fieldIndex, renderCellDefault, rowIndex, dataItem, cellAttributes) => {

    let self = this;
    let rowKey = JSON.stringify(dataItem.getRowKey(row));

    if(fieldInfo.Name === "ComplexRouteGrid") {

      //let isExpanded = this.state.subGridLinkedExpandState[rowKey];
      let isExpanded = this.state.subGridExpandState[dataItem.methodName] && this.state.subGridExpandState[dataItem.methodName][rowKey];

      let className = isExpanded ? "zmdi zmdi-chevron-up" : "zmdi zmdi-chevron-down";

      return (
        <span className={className} onClick={function(e) { self.onToggleSubGrid(rowIndex, row, dataItem, "ComplexRouteGrid"); }} style={{ cursor: "pointer", marginLeft: "10px", marginRight: "10px" }}/>
      );
    }
    else if(fieldInfo.Name === "SuppSumma") {
      //custom handler to show tooltip
      let tooltipText = DrawAttribute.cellTooltipProvider(dataItem, rowIndex, fieldInfo);
      return (
          <div>
            {renderCellDefault(row, fieldInfo, fieldIndex)}
            {
              tooltipText &&
              <i className="fa fa-info-circle pl-2 gridcell-tooltip" data-toggle="tooltip" data-placement="top"
               title={tooltipText}></i>
            }
          </div>
      );
    }

    return renderCellDefault(row, fieldInfo, fieldIndex);
  };

  renderBody = () => {

    let actNumber = this.props.servicesActDescribe.getField(0, "DocumentNumber");
    let actDate = formatMnDate(this.props.servicesActDescribe.getField(0, "DocumentDate"));
    let self = this;
    let allowSend = this.props.servicesActDescribe.getField(0, "AllowSend") === 1;

    return (
      <React.Fragment>
        <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
          <div className="col-12">
            <h1 className="page-title" style={{display: 'inline-block', marginRight: '25px'}}>
              {i18next.t("ActTitle", {number: actNumber, date: actDate})}
            </h1>
            <button className="btn mn-btn-link float-right" style={{fontSize: "25px"}}
                    onClick={this.navigateBack}
            >
              <i className="zmdi zmdi-close" />
            </button>
            {allowSend && <button className="btn btn-regular btn-carrier-action" onClick={self.onSendActClick}>{i18next.t("SendButton")}</button>}
          </div>
        </div>

        {this.isActEditable() &&
        <>
          <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
            <div className="col-md-12">
              <h6 className="page-title">{i18next.t("RetainedRequirements")}</h6>
            </div>
          </div>

          <ComplexParam dataItem={this.props.servicesActPLListParams} readOnly={false} showSearchBar={false}
                        showApplyButton={false} rootPath="/" parentDataItem={this.props.servicesActPLList}
                        autoApplyParams={true} renderParams={this.renderViewGridParams}/>

          <div className="row">&nbsp;</div>

          <GridView dataItem={this.props.servicesActPLList}
                    allowPagination
                    activePageSize={10}
                    renderRow={this.renderViewGridRow}
                    renderCell={this.renderViewGridCell}
                    showHeader={true}
                    updateStateFlag={this.state.updateGridFlag}/>
        </>
        }

        <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
          <div className="col-md-12">
            <h6 className="page-title">{i18next.t("AddedToAct", {number: actNumber, date: actDate})}</h6>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <div className="field-title" style={{textAlign: "left"}}>
              {i18next.t("SearchLabel")}
            </div>
            <SearchBar dataItem={this.props.servicesActPLLinkedList} />
          </div>
        </div>

        <GridView dataItem={this.props.servicesActPLLinkedList}
                  allowPagination
                  activePageSize={10}
                  renderRow={this.renderLinkedGridRow}
                  renderCell={this.renderLinkedGridCell}
                  showHeader={true}
                  readOnly={!this.isActEditable()}
                  updateStateFlag={this.state.updateGridFlag}
        />

      </React.Fragment>
    );
  };

  render() {
    return (
      <div>
        {this.state.initialized
          ? this.renderBody()
          : <h6 className={"mt20"}>{i18next.t('LoadingLabel')}</h6>
        }
      </div>
    );
  }
}

ServicesActEdit.propTypes = {
  dispatch: PropTypes.func.isRequired
};


ServicesActEdit.defaultProps = {
  //myProp: <defaultValue>
};

function mapStateToProps(state, ownProps) {
  return {
    servicesActDescribe: state.servicesActsState.servicesActDescribe,
    servicesActPLList: state.servicesActsState.servicesActPLList,
    servicesActPLListParams: state.servicesActsState.servicesActPLListParams,
    servicesActPLLinkedList: state.servicesActsState.servicesActPLLinkedList,
    servicesActPLInsertList: state.servicesActsState.servicesActPLInsertList,
    servicesActPLDeleteList: state.servicesActsState.servicesActPLDeleteList,
    servicesActsSend: state.servicesActsState.servicesActsSend,
    servicesActsList: state.servicesActsState.servicesActsList,
  };
}

export default withRouter(connect(mapStateToProps)(ServicesActEdit));